import { Box, Header, Text, makeUclComponent } from '@rbilabs/universal-components';

import Button, { ActionButtonVariants } from 'components/action-button';
import Link from 'components/link';

export const OrderIssuesContainer = Box.withConfig({
  marginTop: '$4',
  paddingTop: {
    base: '$4',
    md: 0,
  },
  paddingX: {
    base: '$6',
    md: 0,
  },
  borderTopWidth: {
    base: 1,
    md: 0,
  },
  borderTopColor: Styles.color.grey.four,
  flexDirection: {
    base: 'column',
    md: 'row',
  },
});

export const OrderIssuesHeading = Header.withConfig({
  textAlign: {
    base: 'center',
    md: 'left',
  },
  marginBottom: '$2.5',
  variant: 'headerThree',
});

export const OrderIssuesText = Text.withConfig({
  textAlign: {
    base: 'center',
    md: 'left',
  },
  margin: 0,
  fontSize: 'xs',
});

export const StyledButton = makeUclComponent(Button).withConfig({
  color: Styles.color.primary,
  variant: ActionButtonVariants.OUTLINE,
  marginLeft: '$24',
  _hover: {
    color: Styles.color.primaryHover,
  },
});

export const StyledLink = makeUclComponent(Link).withConfig({
  color: Styles.color.primary,
  isUnderlined: false,
  _hover: {
    color: Styles.color.primaryHover,
  },
});
